<template>
  <div class="regist">
    <div
      v-show="currentStep===0?true:false"
      class="registArea"
    >
      <div class="currentSteps">
        <el-steps :active="currentStep+1">
          <el-step
            title="填写注册信息"
            description=""
          ></el-step>
          <el-step
            title="完善联系信息"
            description=""
          ></el-step>
          <el-step
            title="完成注册"
            description=""
          ></el-step>
        </el-steps>
      </div>
      <div class="formArea">
        <el-form
          ref="registStepOne"
          :rules='rules'
          :model='registFormOneData'
        >
          <el-form-item
            label=''
            prop='loginName'
          >
            <el-input
              prefix-icon="el-icon-phone"
              :maxlength="11"
              v-model="registFormOneData.loginName"
              placeholder='请输入手机号'
              @input="changeNumber"
            ></el-input>
          </el-form-item>
          <el-form-item
            label=''
            prop='validateCode'
          >
            <div class="velidateArea">
              <el-input
                prefix-icon="el-icon-lollipop"
                v-model="registFormOneData.validateCode"
                @change="checkVerCode"
                placeholder='请输入验证码'
              ></el-input>
              <div
                :class="isHasPhone ? 'velidateCode' : 'disabled'"
                @click="sendVerCode"
                v-if="!isDisabled"
              >发送验证码
              </div>
              <div
                class="disabled"
                v-else
              >{{ count }}秒
              </div>
            </div>
          </el-form-item>
          <el-form-item
            label=''
            prop='password'
          >
            <el-input
              type='password'
              prefix-icon="el-icon-lock"
              v-model="registFormOneData.password"
              placeholder='请输入密码'
            ></el-input>
          </el-form-item>
          <el-form-item
            label=''
            prop='repassword'
          >
            <el-input
              prefix-icon="el-icon-lock"
              type='password'
              v-model="registFormOneData.repassword"
              placeholder='请再次输入密码'
            ></el-input>
          </el-form-item>
          <el-form-item>
            <div class="inputLabel"></div>
            <div class="nextStep">
              <el-button
                type='primary'
                @click="nextStep(0)"
              >下一步
              </el-button>
            </div>
          </el-form-item>
          <el-form-item
            label=''
            prop='agreement'
          >
            <div
              class=""
              style="margin-top:10px"
            >
              <el-checkbox v-model="agreement">同意并接受</el-checkbox>
              <router-link
                to="/userAgreement"
                target="_blank"
              >
                <span style="color:#458cff;cursor:pointer">《用户协议》</span>
              </router-link>
              <router-link
                to="/privacyPolicy"
                target="_blank"
              ><span class="login-txt">《隐私策略》</span></router-link>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="login">
        已有账号?<span
        class="login-txt"
        @click="$router.push('/login')"
      >立即登录</span>
      </div>
    </div>
    <!-- 第二步 -->
    <div
      v-show="currentStep===1"
      class="registArea"
    >
      <div class="currentSteps">
        <el-steps :active="currentStep+1">
          <el-step
            title="填写注册信息"
            description=""
          ></el-step>
          <el-step
            title="完善联系信息"
            description=""
          ></el-step>
          <el-step
            title="完成注册"
            description=""
          ></el-step>
        </el-steps>
      </div>
      <div class="formArea">
        <el-form
          ref="registStepTwo"
          :model='registFormTwoData'
          :rules='rules'
        >
          <el-form-item
            label=''
            prop='name'
          >
            <el-input
              prefix-icon="el-icon-s-shop"
              v-model="registFormTwoData.name"
              placeholder='店铺名称'
            ></el-input>
          </el-form-item>
          <el-form-item
            label=''
            :prop='addressProp'
          >
            <div
              class="addressChoose"
              style="display:flex"
            >
              <el-select
                prefix-icon="el-icon-location-outline"
                @change="provinceChange"
                v-model="registFormTwoData.province"
                filterable
                placeholder="省"
              >
                <el-option
                  v-for="item in registFormTwoData.provinceOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-select
                v-model="registFormTwoData.city"
                filterable
                placeholder="市"
              >
                <el-option
                  v-for="item in registFormTwoData.cityOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-input
                v-model="registFormTwoData.address"
                placeholder='请输入详细地址'
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item
            label=''
            prop='email'
          >
            <el-input
              prefix-icon="el-icon-message"
              v-model="registFormTwoData.email"
              placeholder='请输入邮箱'
              @blur="sendEmail"
            ></el-input>
          </el-form-item>
          <el-form-item
            label=''
            prop=''
          >
            <el-input
              prefix-icon="el-icon-magic-stick"
              v-model="registFormTwoData.inviteCode"
              placeholder='请输入邀请码'
            ></el-input>
          </el-form-item>
          <el-form-item>
            <div class="inputLabel"></div>
            <div class="preSubmit">
              <el-button
                type='primary'
                @click="submit"
              >提交
              </el-button>
            </div>
          </el-form-item>
          <el-form-item
            label=''
            prop='agreement'
          >
            <div
              class=""
              style="display:flex;margin-top:10px"
            >
              <el-checkbox v-model="agreement">同意并接受</el-checkbox>
              <router-link
                to="/userAgreement"
                target="_blank"
              >
                <span style="color:#458cff;cursor:pointer">《用户协议》</span>
              </router-link>
              <router-link
                to="/privacyPolicy"
                target="_blank"
              ><span class="login-txt">《隐私策略》</span></router-link>
              <div
                style="margin-left:auto;cursor:pointer;color:#fff"
                @click="currentStep=currentStep-1"
              >上一步
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="login">
        已有账号?<span
        class="login-txt"
        @click="$router.push('/login')"
      >立即登录</span>
      </div>
    </div>
    <!-- 拼图显示 -->
    <!-- <div
      v-show="puzzleShow"
      class="registArea"
      v-loading="loading"
    >
      <div class="puzzleTitle">
        <span
          class="backAccount"
          @click="puzzleShow=false;currentStep=1"
        >返回</span>安全验证
      </div>
      <Paper
        :diff="diff"
        :tipError.sync='tipError'
      ></Paper>
      <Slide
        @change="slideChange"
        @validate='puzzleResult'
      ></Slide>
    </div> -->
    <!-- 第三步 -->
    <div
      v-show="currentStep===2"
      class="registArea"
    >
      <div class="currentSteps">
        <el-steps :active="currentStep+1">
          <el-step
            title="填写注册信息"
            description=""
          ></el-step>
          <el-step
            title="完善联系信息"
            description=""
          ></el-step>
          <el-step
            title="完成注册"
            description=""
          ></el-step>
        </el-steps>
      </div>
      <div class="successArea">
        <div class="circle"><i class="el-icon-check"></i></div>
        <div class="login-txt">完成注册</div>
      </div>
      <div class="login">
        已有账号?<span
        class="login-txt"
        @click="$router.push('/login')"
      >立即登录</span>
      </div>
    </div>
    <div
      v-loading.fullscreen.lock="loading"
      element-loading-text="提交数据中，请稍等片刻。。。"
      element-loading-background="rgba(0, 0, 0, 0.5)"
    >
    </div>
    <div
      v-show="currentStep===3"
      class="registArea"
    >
      <div class="successArea">
        <div class="circleX"><i class="el-icon-close"></i></div>
        <div class="login-txt">注册失败</div>
      </div>
      <div class="login">已有账号?<span class="login-txt" @click="$router.push('/login')">立即登录</span></div>
    </div>
  </div>
</template>

<script>
import api from "@/config/api.js";
import Paper from "@/components/controls/paper.vue";
import Slide from "@/components/controls/slide.vue";

export default {
  data() {
    let checkLoginName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {

        const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    let checkPass = (rule, value, callback) => {
      this.$refs.registStepOne.validateField("repassword");
      this.$refs.registStepOne.validateField("repassword");
      callback();
    };
    let checkPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请再次输入密码"));
      } else if (value !== this.registFormOneData.password) {
        return callback(new Error("两次输入密码不一致"));
      } else {
        callback();
      }
    };
    let checkAgreement = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请先阅读协议"));
      } else {
        callback();
      }
    };
    let checkAddres = (rule, value, callback) => {
      let addressProps = ["province", "city", "address"];
      let message = ["请选择所在省", "请选择所在市", "请填写详细地址"];
      for (let i = 0; i < addressProps.length; i++) {
        this.addressProp = addressProps[i];
        if (!this.registFormTwoData[addressProps[i]]) {
          return callback(new Error(message[i]));
        } else if (i === 2) {
          //走此if说明当前验证的字段默认存在，加条件当是验证第三个字段时可放行。因为前面省市虽然存在不一定代表验证通过
          callback();
        }
      }
    };
    return {
      merchantId: '',
      merchantNo: '',
      isTrueCode: false,
      isHasPhone: false,
      loading: false,
      content: "短信验证码",
      isDisabled: false, // 短信发送按钮
      count: 60,
      addressProp: "province", //地址循环校验
      agreement: false,
      tipError: false, //拼图相关字段
      puzzleShow: false,
      diff: 0, //拼图拖动距离
      registFormOneData: {
        loginName: "",
        password: "",
        repassword: "",
        validateCode: "",
        agreement: false,
      },
      registFormTwoData: {
        name: "",
        specialty: "",
        province: "",
        city: "",
        address: "",
        email: "",
        agreement: false,
        inviteCode: '',
        provinceOptions: [],
        cityOptions: [],
      },
      rules: {
        loginName: [{validator: checkLoginName, trigger: "blur"}],
        password: [{validator: checkPass, trigger: "blur"}],
        repassword: [{validator: checkPassword, trigger: "blur"}],
        validateCode: [
          {required: true, message: "请输入验证码", trigger: "blur"},
        ],
        agreement: [{validator: checkAgreement}],
        name: [{required: true, message: "请输入店铺名称", trigger: "blur"}],
        specialty: [
          {required: true, message: "请选择所属行业", trigger: "change"},
        ],
        province: [{validator: checkAddres}],
        city: [{validator: checkAddres}],
        address: [{validator: checkAddres}],
        email: [{required: true, message: "请输入邮箱", trigger: "blur"}],
      },
      currentStep: 0,
      options: [],
      value: "",
    };
  },
  components: {
    Paper,
    Slide,
  },
  watch: {
    agreement: {
      handler(val, old) {
        this.registFormOneData.agreement = this.registFormTwoData.agreement =
          val;
      },
    },
  },
  created() {
    this.refontSize();
    this.getRegionList(0, this.registFormTwoData.provinceOptions);
    let currentUrl = window.location.href; //获取当前链接
    // var currentUrl = 'http://322n599v37.qicp.vip?inviteCode=88223123'
    if (currentUrl.indexOf('?') != -1 && currentUrl.indexOf('inviteCode') != -1) {
      let strCode = currentUrl.split("?")[1]
      this.registFormTwoData.inviteCode = strCode.split("=")[1]
    } else {
      this.registFormTwoData.inviteCode = ''
    }
  },
  methods: {
    // 邮箱验证
    sendEmail() {
      var regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (this.registFormTwoData.email != '' && !regEmail.test(this.registFormTwoData.email)) {
        this.$message({
          message: '邮箱格式不正确',
          type: 'error'
        })
        this.registFormTwoData.email = ''
      }
    },
    // 输入手机号
    changeNumber(val) {
      if (val.length == 11) {
        this.inputPhoneNumber()
      } else {
        this.isHasPhone = false
      }
    },
    // 验证手机号码是否注册
    inputPhoneNumber() {
      return new Promise((reslove, reject) => {
        if (this.registFormOneData.loginName && /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.registFormOneData.loginName)) {
          this.$axios.fetchGet(api.sysUserVerifyPhone + '?phone=' + this.registFormOneData.loginName, {}).then((res) => {
            if (res.code == 200) {
              if (res.data) {
                this.isHasPhone = true;
              } else {
                this.isHasPhone = false;
                this.$message({
                  message: "该号码已注册",
                  type: "warning",
                });
              }
              reslove(this.isHasPhone)
            } else {
              reject(res.errorMsg)
            }
          })
        }
      })
    },
    // 倒计时
    timer() {
      if (this.count == 0) {
        this.isDisabled = false;
        this.count = 0;
      } else {
        this.isDisabled = true;
        this.count--;
        setTimeout(() => {
          this.timer();
        }, 1000);
      }
    },
    // 获取验证码
    sendVerCode() {
      this.inputPhoneNumber().then(() => {
        if (this.isHasPhone) {
          let url = api.getPhoneCode + '?phone=' + this.registFormOneData.loginName;
          this.$axios.fetchPost(url, {}).then((res) => {
            if (res.code === 200) {
              this.$nextTick(() => {
                this.count = 60;
                this.timer();
              })
            } else {
              this.$message.error("短信发送失败:" + res.errorMsg);
            }
          });
        }
      })
    },
    checkVerCode(code) {
      if (
        !this.registFormOneData.loginName ||
        this.registFormOneData.loginName === ""
      ) {
        return;
      }
      let url =
        "/api/eros/se/seMerchant/check/verCode?phone=" +
        this.registFormOneData.loginName +
        "&validateCode=" +
        code;
      this.$axios
        .fetchPost(url, {})
        .then((res) => {
          if (res.code === 200) {
            if (!res.data) {
              this.registFormOneData.validateCode = "";
              this.$message({
                message: "请输入正确验证码",
                type: "error",
              });
              this.isTrueCode = false
            } else {
              this.isTrueCode = true
            }
          } else {
            this.$message.error("发送异常");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 下一步
    nextStep(stepIndex) {
      let url =
        "/api/eros/se/seMerchant/check/verCode/v2?phone=" +
        this.registFormOneData.loginName +
        "&validateCode=" +
        this.registFormOneData.validateCode +
        "&password=" + this.registFormOneData.repassword
      this.$axios
        .fetchPost(url, {})
        .then((res) => {
          if (res.code === 200) {
            this.merchantId = res.data.id;
            this.merchantNo = res.data.merchantNo;
            this.currentStep = 1;
          } else {
            this.$message.error("发送异常");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 提交
    submit() {
      this.$refs.registStepTwo.validate((valid) => {
        if (valid) {
          this.currentStep = -1;
          this.loading = true;
          let url = "/api/eros/se/seMerchant/register/submit";
          let params = {
            ...this.registFormOneData,
            ...this.registFormTwoData,
          };
          Object.assign(params, {id: this.merchantId, merchantNo: this.merchantNo});
          this.$axios
            .fetchPost(url, params)
            .then((res) => {
              if (res.code === 200) {
                this.currentStep = 2;
              } else {
                this.currentStep = 3;
                this.$message.error(res.errorMsg || '注册失败');
              }
              this.loading = false;
            })
            .catch((err) => {
              this.$message.error(err.errorMsg);
            });
        } else {
          return false;
        }
      });
    },

    refontSize() {
      document.documentElement.style.fontSize =
        (document.documentElement.clientWidth / 1920) * 10 + "px";
    },
    provinceChange(value) {
      this.getRegionList(value, this.registFormTwoData.cityOptions, "city");
    },
    getRegionList(id, options, areaUnit = "") {
      options.length = 0;
      //两个地区单位置空
      if (areaUnit) {
        this.registFormTwoData[areaUnit] = "";
      }

      let url = api.getAreaList + "?parentId=" + id;
      this.$axios.fetchPost(url).then((res) => {
        if (res.code === 200) {
          for (let i = 0; i < res.data.length; i++) {
            let objectAdaptor = {
              label: res.data[i].name,
              value: res.data[i].id,
            };
            options.push(objectAdaptor);
          }
        } else {
          this.$message.error("地区集合获取失败！" + res.errorMsg);
        }
      });
    },
  },
};
</script>

<style scoped>
.regist {
  width: 100%;
  height: 100%;
  min-width: 1200px;
  background-image: url("../assets/images/login-bg2.png");
  background-size: 100% 100%;
  padding: 150px 90px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
}

.regist .login-txt {
  color: #458cff;
  cursor: pointer;
}

.registArea {
  width: 30vw;
  margin: auto;
  background-color: rgba(0, 0, 0, 0.3);
  padding: 40px;
  border-radius: 2rem;
  font-size: 1.8rem;
}

.registArea .successArea {
  /* height: 68.6rem; */
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
}

.registArea .successArea .circle {
  width: 9.8rem;
  height: 9.8rem;
  border-radius: 50%;
  border: 1px solid #458cff;
  background-color: #458cff;
  margin-bottom: 10px;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  font-size: 6.4rem;
  color: #fff;
}

.registArea .successArea .circleX {
  width: 9.8rem;
  height: 9.8rem;
  border-radius: 50%;
  border: 1px solid red;
  background-color: red;
  margin-bottom: 10px;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  font-size: 6.4rem;
  color: #fff;
}

.registArea .inputLabel {
  font-size: 1.8rem;
  margin-top: 3.8rem;
  margin-bottom: 1rem;
}

.registArea .formArea .velidateArea {
  display: flex;
  justify-content: space-between;
}

.login {
  text-align: center;
  margin-top: 6rem;
  color: #fff;
}

/* 拼图样式 */
.puzzleTitle {
  font-size: 1.6rem;
  color: #000000;
  font-weight: bold;
  margin-bottom: 1rem;
  text-align: center;
  padding: 0px 0px 1rem 0px;
  border-bottom: 1px solid #d7d7d7;
}

.puzzleTitle .backAccount {
  float: left;
  color: #007aff;
  font-size: 1.2rem;
  font-weight: 500;
  cursor: pointer;
  line-height: 2rem;
}

.disabled {
  display: inline-block;
  height: 45px;
  line-height: 45px;
  width: 26%;
  vertical-align: bottom;
  text-align: center;
  margin-left: 10px;
  background-color: #f2f2f2;
  border-radius: 1rem;
  cursor: unset;
  color: #999;
}

.velidateCode {
  display: inline-block;
  height: 45px;
  line-height: 45px;
  width: 26%;
  vertical-align: bottom;
  text-align: center;
  margin-left: 10px;
  background-color: #f2f2f2;
  border-radius: 1rem;
  cursor: pointer;
  color: #000;
}

.nextStep button {
  width: 100%;
  height: 45px;
}

.preSubmit {
  display: flex;
  justify-content: space-between;
}

.preSubmit button {
  width: 100%;
  height: 45px;
}

.regist >>> .el-input {
  height: 45px;
  width: 100%;
}

.regist >>> .el-input__inner {
  height: 45px;
  line-height: 45px;
  font-size: 1.8rem;
  border: 1px solid #f2f2f2;
  background-color: #f2f2f2;
  border-radius: 1rem;
}

.regist >>> .el-input__inner:focus {
  border: 1px solid #458cff;
  background-color: #fff;
  border-radius: 1rem;
}

/* 步骤条 */
.regist >>> .el-steps--horizontal {
  white-space: nowrap;
  width: 80%;
  margin: 10px auto;
}

.regist >>> .el-step__icon.is-text {
  background-color: #dadada;
  color: #fff;
  border: none;
}

.regist >>> .is-finish .el-step__icon.is-text {
  border-radius: 50%;
  background-color: #458cff;
  color: #fff;
}

.regist >>> .el-step__line {
  background-color: #dadada;
}

.regist >>> .is-finish div[class~="el-step__line"] {
  background-color: #458cff;
}

.regist >>> .el-step__title.is-finish {
  color: #458cff;
  font-size: 1.6rem;
}

.regist >>> .el-step__title.is-process {
  color: #dadada;
  font-size: 1.6rem;
}

.regist >>> .el-step__title.is-wait {
  color: #dadada;
  font-size: 1.6rem;
}

.regist >>> .el-select {
  width: 100%;
  height: 45px;
  line-height: 45px;
  border-color: #b2b2b2;
  font-size: 1.8rem;
  border-radius: 6px;
  max-width: 100%;
  z-index: 10;
  background-color: #fff;
}

.regist >>> .el-select-dropdown__item {
  font-size: 1.8rem;
}

.regist >>> .addressChoose .el-select {
  width: 26rem;
  margin-right: 10px;
}

.regist .el-form-item {
  margin-bottom: 15px;
}

</style>



// WEBPACK FOOTER //
// src/page/Regist.vue